import firebase from "firebase/app";
import "firebase/firestore";

export async function getAppIds() {
    var db = firebase.firestore();
    var snapshot = await db.collection("app_ids").get();
    var result = {};
    snapshot.docs.forEach((doc) => {
        result[doc.id] = (doc.data().ids || []).map((id) => id.trim());
    });
    return result;
}

export async function addAppId(appId, env, userId) {
    var db = firebase.firestore();
    var docRef = db.collection("app_ids").doc(env);
    var existing = await docRef.get();
    if (existing.exists && (existing.data().ids || []).includes(appId)) {
        throw new Error("App ID already exists");
    }
    return await docRef.set(
        { ids: firebase.firestore.FieldValue.arrayUnion(appId) },
        { merge: true }
    );
}

export async function deleteAppId(appId, env) {
    var db = firebase.firestore();
    return await db.collection("app_ids").doc(env).update({
        ids: firebase.firestore.FieldValue.arrayRemove(appId),
    });
}
